export type ProfessionId =
  | 'lash'
  | 'esthe'
  | 'brow'
  | 'nail'
  | 'makeup'
  | 'hair'
  | 'wax'
  | 'spa'
  | 'massage'
  | 'studio'
  | 'client';

export interface ProfessionDef {
  id: ProfessionId;
  brandLabel: string;
  specialty: string;
  userType: 'professional' | 'client';
  color: string;
}

/** Single source of truth for professions across signup, onboarding, landing, directory. */
export const PROFESSIONS: ProfessionDef[] = [
  {
    id: 'lash',
    brandLabel: 'LashMatch',
    specialty: 'Lash Artist',
    userType: 'professional',
    color: '#8b7cf8',
  },
  {
    id: 'esthe',
    brandLabel: 'EstheMatch',
    specialty: 'Esthetician',
    userType: 'professional',
    color: '#10b981',
  },
  {
    id: 'brow',
    brandLabel: 'BrowMatch',
    specialty: 'Brow Artist',
    userType: 'professional',
    color: '#c4b5fd',
  },
  {
    id: 'nail',
    brandLabel: 'NailMatch',
    specialty: 'Nail Artist',
    userType: 'professional',
    color: '#f59e0b',
  },
  {
    id: 'makeup',
    brandLabel: 'MakeupMatch',
    specialty: 'Makeup Artist',
    userType: 'professional',
    color: '#ef4444',
  },
  {
    id: 'hair',
    brandLabel: 'HairMatch',
    specialty: 'Hair Professional',
    userType: 'professional',
    color: '#06b6d4',
  },
  {
    id: 'wax',
    brandLabel: 'WaxMatch',
    specialty: 'Waxing',
    userType: 'professional',
    color: '#f97316',
  },
  {
    id: 'spa',
    brandLabel: 'SpaMatch',
    specialty: 'Spa',
    userType: 'professional',
    color: '#a855f7',
  },
  {
    id: 'massage',
    brandLabel: 'MassageMatch',
    specialty: 'Massage Therapist',
    userType: 'professional',
    color: '#14b8a6',
  },
  {
    id: 'studio',
    brandLabel: 'StudioMatch',
    specialty: 'Studio / Salon',
    userType: 'professional',
    color: '#8b5cf6',
  },
  { id: 'client', brandLabel: 'Client', specialty: 'Client', userType: 'client', color: '#f43f5e' },
];

export const PROFESSIONAL_PROFESSIONS = PROFESSIONS.filter((p) => p.userType === 'professional');

export function getProfession(id: string | null | undefined): ProfessionDef | undefined {
  return PROFESSIONS.find((p) => p.id === id);
}

export function professionToSpecialty(id: string | null | undefined): string {
  return getProfession(id)?.specialty || 'Beauty Professional';
}

export function professionToBrandLabel(id: string | null | undefined): string {
  return getProfession(id)?.brandLabel || 'StudioMatch';
}

export function specialtyMatchesFilter(specialtyOrProfession: string, filterId: string): boolean {
  const hay = specialtyOrProfession.toLowerCase();
  const needle = filterId.toLowerCase();
  if (hay.includes(needle)) return true;
  const def = getProfession(filterId);
  if (def && hay.includes(def.specialty.toLowerCase())) return true;
  if (def && hay.includes(def.brandLabel.toLowerCase())) return true;
  return false;
}

export const DIRECTORY_SPECIALTY_FILTERS = [
  'All',
  ...PROFESSIONAL_PROFESSIONS.map((p) => p.brandLabel),
];

export const CLIENT_SPECIALTY_FILTERS = [
  'All',
  ...PROFESSIONAL_PROFESSIONS.map((p) => p.specialty),
];
